
import { FirearmStorageLocationPLIMetadataBase } from './firearm-storage-location-pli.metadata.base';


export class FirearmStorageLocationPLIMetadata extends FirearmStorageLocationPLIMetadataBase {
  constructor() {
    super();
  }
}

export const FIREARM_STORAGE_LOCATION_PLI_METADATA: FirearmStorageLocationPLIMetadata = new FirearmStorageLocationPLIMetadata();


